import { render, staticRenderFns } from "./CadastroRateioMedico.vue?vue&type=template&id=4ab5514a&"
import script from "./CadastroRateioMedico.vue?vue&type=script&lang=js&"
export * from "./CadastroRateioMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports